<template>
  <div class="details-container">
    <b-row>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'promotions_price_list' | i18n }}:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.promotionsPriceList }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'promotions_price_list' | i18n }} Kz:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.promotionsPriceListKz }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'special_price_list' | i18n }} 1:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.specialPriceList1 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'special_price_list' | i18n }} Kz 1:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.specialPriceListKz1 }}
      </b-col>

      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'special_price_list' | i18n }} 2:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.specialPriceList2 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'special_price_list' | i18n }} Kz 2:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.specialPriceListKz2 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'special_price_list' | i18n }} 3:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.specialPriceList3 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'special_price_list' | i18n }} Kz 3:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.specialPriceListKz3 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'special_price_list' | i18n }} 4:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.specialPriceList4 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'special_price_list' | i18n }} Kz 4:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.specialPriceListKz4 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'special_price_list' | i18n }} 5:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.specialPriceList5 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'special_price_list' | i18n }} Kz 5:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.specialPriceListKz5 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'zu_ab_art' | i18n }} 1:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.zuAbArt1 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'to_discount' | i18n }} 1:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.toDiscount1 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'zu_ab_art' | i18n }} 2:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.zuAbArt2 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'to_discount' | i18n }} 2:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.toDiscount2 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'zu_ab_art' | i18n }} 3:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.zuAbArt3 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'to_discount' | i18n }} 3:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.toDiscount3 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'price_determination_bulk_price' | i18n }}:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.priceDeterminationBulkPrice }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'minimum_value' | i18n }}:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.minimumValue }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'special_price' | i18n }} Kz:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.specialPriceKz }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'minimum_quantity_level' | i18n }}:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.minimumQuantityLevel }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'maximum_quantity_level' | i18n }}:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.maximumQuantityLevel }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'quantity_levels_shift' | i18n }}:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.quantityLevelsShift }}
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {BCol, BRow} from 'bootstrap-vue';

export default {
  name: 'ConditionsTableDetailsRow',
  components: {'b-row': BRow, 'b-col': BCol},
  props: {
    row: {
      type: Object,
      default: () => {
      }
    }
  }
};
</script>

<style scoped>

</style>
